import React, { useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getPerformanceRatingToolTipData } from "../Functions/Constant";
// import { InfoCircle } from "react-bootstrap-icons";

export default function InfoTooltipRating({ className="", rating }) {
//   useEffect(() => {
//     // Ensure tooltips work properly
//     const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
//     tooltipTriggerList.forEach(tooltip => new window.bootstrap.Tooltip(tooltip));
//   }, []);
const tooltipText = getPerformanceRatingToolTipData(rating);
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-top" className="custom-tooltip">
      {tooltipText.description} </Tooltip>}
    >
      <span className={className}>{tooltipText.level}</span>
      
    </OverlayTrigger>
  );
}

